import script from "./ProcedureBlocks.vue?vue&type=script&setup=true&lang=js"
export * from "./ProcedureBlocks.vue?vue&type=script&setup=true&lang=js"

import "./ProcedureBlocks.vue?vue&type=style&index=0&id=43858bc9&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43858bc9"]])

export default __exports__